import React from "react";
import { useSelector } from "react-redux";
import Tooltip from "components/design-system/tooltip";
import Price from "components/source/grid/price";
import { showDecimal } from "helpers/price-helper";
import { normalizePrice } from "helpers/PricingHelper";
import { Faq } from "routes";

const ClearancePrice = () => {
  const staticProduct = useSelector(state => state.staticProduct);
  const clearancePricing = useSelector(state => state.pdp?.clearance?.pricing?.response?.price || []);
  const clearancePriceMap = Object.fromEntries(
    clearancePricing.map(({ id, value, discount }) => [id, { value, discount }])
  );

  const msrp = clearancePriceMap["msrp"]?.value || staticProduct.msrp;
  const salePrice = clearancePriceMap["sale"]?.value;
  const discount = clearancePriceMap["sale"]?.discount;
  const discountPercent = typeof discount === "number" ? Math.round(discount * 100) : discount;

  const tooltipContent = (
    <div className="w-64 p-2">
      This number represents the “Original Retail” or “Comparable Value” price. Items may be in the rental rotation for
      multiple seasons after these prices are set. For more info on these prices, see our{" "}
      <a href={Faq.purchasePricing} rel="noopener noreferrer" target="_blank">
        FAQs
      </a>
    </div>
  );

  return (
    <div className="flex text-mutedRed mt-1">
      <div className="mr-2 semibold">{normalizePrice(salePrice)}</div>
      <div className="mr-2 flex">
        <span className="pr-2 border-r border-offWhite">{discountPercent}% off (Final Sale)</span>
        <div className="text-darkerGray ml-2 flex gap-1">
          <Price
            amount={msrp}
            currencyCode="USD"
            currencyCodeClassName="hidden @[275px]/label:inline"
            showDecimal={showDecimal(msrp)}
          />
          <span>original retail</span>
          <Tooltip className="ml-1 inline-flex items-center" position="left" tooltipContent={tooltipContent} />
        </div>
      </div>
    </div>
  );
};

export default ClearancePrice;
